import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	singleCreateWorkItemNameUpdated: {
		id: 'jira-work-create-extension.single-create-work-item.name.updated',
		defaultMessage: 'Jira work item',
		description: 'Name for the single create work item button',
	},
	bulkCreateWorkItemNameUpdated: {
		id: 'jira-work-create-extension.bulk-create-work-item.name.updated',
		defaultMessage: 'Jira work items',
		description: 'Name for the bulk create work item button',
	},
});
